import ajax from '@utils/ajax';

const rootUrl = '/capsiminbox/admin/api/questionGroup';

export const addQuestionGroup = async ({ payload }) =>
  await ajax('POST', `${rootUrl}`, JSON.stringify(payload));
